import './ProfilePage.css';

export default function ProfilePage() {
    return (
      <section className="profile_page">
        <p className="title">Профиль</p>
      </section>
    );
  }